import React, { useState, useEffect } from "react";

export default function StudentProfileModal({ student, onClose, onSave }) {
  const [form, setForm] = useState({});

  useEffect(() => {
    setForm({ ...student, name: student?.name || `${student?.firstName || ""} ${student?.lastName || ""}`.trim() });
  }, [student]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    onSave(form);
  };

  if (!student) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-lg w-full max-w-2xl p-6 shadow-lg">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold">Student Profile</h3>
          <button onClick={onClose} className="text-gray-600">✕</button>
        </div>

        <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="md:col-span-2">
            <label className="text-sm text-gray-600">Name</label>
            <input name="name" value={form.name || ""} onChange={handleChange} className="w-full border px-3 py-2 rounded" />
          </div>

          <div>
            <label className="text-sm text-gray-600">Class</label>
            <input name="className" value={form.className || ""} onChange={handleChange} className="w-full border px-3 py-2 rounded" />
          </div>

          <div>
            <label className="text-sm text-gray-600">Section</label>
            <input name="section" value={form.section || ""} onChange={handleChange} className="w-full border px-3 py-2 rounded" />
          </div>

          <div>
            <label className="text-sm text-gray-600">Email</label>
            <input name="email" value={form.email || ""} disabled className="w-full border px-3 py-2 rounded bg-gray-50 text-gray-500" />
          </div>

          <div>
            <label className="text-sm text-gray-600">Contact</label>
            <input name="contact" value={form.contact || ""} disabled className="w-full border px-3 py-2 rounded bg-gray-50 text-gray-500" />
          </div>

          <div className="md:col-span-2">
            <label className="text-sm text-gray-600">Address</label>
            <textarea name="address" value={form.address || ""} disabled className="w-full border px-3 py-2 rounded bg-gray-50 text-gray-500" />
          </div>

          <div className="md:col-span-2 flex justify-end gap-3 mt-2">
            <button type="button" onClick={onClose} className="px-4 py-2 border rounded">Cancel</button>
            <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded">Save</button>
          </div>
        </form>
      </div>
    </div>
  );
}
